// extracted by mini-css-extract-plugin
export default {"root":"ComboGroup_root__8GVvo","choices-wrapper":"ComboGroup_choices-wrapper__cUqfa"};